goog.provide('el8.appchart.dialog.ordermed.validate');

goog.require('el8.appchart.dialog.selectPrescribingPhysician');
goog.require('el8.appchart.permissions');
goog.require('el8.service.tz');
goog.require('el8.util.datecompare');


el8.appchart.dialog.ordermed.validate = function(main, medOrder, isEPrescribe, saveFn) {

    // Do Rx specific validation
    isEPrescribe = (isEPrescribe === true); //defaults to false

    if (main._isRx) {
        if (medOrder.isSelfPrescribed()) {
            return {
                result: false,
                msg : 'Rx cannot be self-prescribed. Please input a prescribing physician.'
            };

        } else if (!medOrder.getPrescribingPhysicianId()) {
            var delegatingPhysicians = el8.data.currUser.getRxDelegatingPhysicianIdsInWorkspace();
            if (el8.data.currUser.isOfficeStaff() || delegatingPhysicians.length) {
                el8.appchart.dialog.selectPrescribingPhysician.show('rxs', function(physicianId) {
                    medOrder.setPrescribingPhysicianId(physicianId);
                    if (saveFn) { saveFn(); }
                });
                return {result: false, msg: ''}; // won't actually show an alert dialog
            }
            return {result : false, msg : 'Please input a prescribing physician.'};

        } else if ((main._data['old_medication_name'] || main._data['old_medication_id'])
                        && !main._data['tx_start_date']) {
            return {result: false, msg: "Please add a tx start date to the old med"};

        } else if (main._data['tx_start_date']) {
            if (el8.util.datecompare.isAfterToday(
                    el8.service.tz.newTzDate(main._data['tx_start_date']))) {
                return {result: false, msg: 'Please enter a tx start date in the past'};
            }
        } else if (!main._isSamples && (medOrder.getAuthRefills() === null ||
                medOrder.getAuthRefills() === '')) {
            return {result: false, msg: 'Please indicate number of authorized refills'};

        } else if (medOrder.getAuthRefills() &&
                (medOrder.getAuthRefills() < 0 || medOrder.getAuthRefills() > 999)) {
            return {
                result: false,
                msg: 'Number of authorized refills must be between 0 and 999'
            };
        }
    }
    // Do validation of refills field and quantity fields
    if (!medOrder.isAuthRefillsNumerical()) {
        return {
            result: false,
            msg: 'Number of authorized refills must be a whole number, with no decimals.'
        };

    } else if (main._isRx && !main._isSamples && !medOrder.getQuantity()) {
        return {result: false, msg: 'Please indicate a quantity.'};

    } else if (main._isRx && isEPrescribe && (parseFloat(medOrder.getQuantity()) === 0)) {
        return {result: false, msg: 'Quantity cannot be 0 for ePrescriptions.'};

    } else if (!medOrder.isQuantityNumerical()) {
        return {result: false, msg: 'Please enter a number in the quantity field.'};

    } else if (main._isRx && !main._isSamples && isEPrescribe && !medOrder.isQuantityUnitsValid(main)) {
        var message;
        var shouldAlertHTML = null;
        if (el8Globals.FEATURES.NewSurescriptsEPCS) {
            message = 'This unit of measure is not supported for ePrescribing. Learn more <a href="https://help.elationemr.com/s/article/deprecated-prescription-units" target="_blank" rel="noopener noreferrer">here</a>. ';
            shouldAlertHTML = true;
        } else {
            message = 'Please enter valid units into quantity units field.';
        }
        return {result: false, msg: message, shouldAlertHTML: shouldAlertHTML};
    }
    // Make sure samples orders have number of samples specified
    if (main._isSamples) {
        if (!medOrder.getNumSamples()) {
            return { result: false, msg: 'Please indicate number of samples given.' };
        }
    }
    if (medOrder.getIcd10Ids().length > 1 && main.isEPrescribingControlled()) {
      return {
        result: false,
        msg: 'You can only send up to 1 diagnosis code to the pharmacy for controlled substances. Please remove additional diagnosis codes.'
      };
    }
    // Limit to max of two ICD-10 codes
    else if (medOrder.getIcd10Ids().length > 2) {
      return {
        result: false,
        msg: 'You can only send up to 2 diagnosis codes to the pharmacy. Please remove additional diagnosis codes.'
      };
    }
    // Do start date validation
    if (medOrder.getStartDate()) {
        var startDate = medOrder.getStartDate();
        try {
            if (!(startDate instanceof Date || startDate instanceof timezoneJS.Date) || startDate.getFullYear() < 1900) { // TODO Hack for now
                throw "error";
            }
        } catch (error) {
            return { result: false, msg: 'Please input a valid start date in ' + Date.format.toUpperCase() + ' format' };
        }
        if (main._isRx) {
            if (!el8.util.datecompare.isTodayOrAfter(startDate)) {
                return {result: false, msg: 'Please enter date that is not in the past.'};
            }
        } else {
            if (el8.util.datecompare.isAfterToday(startDate)) {
                return {result: false, msg: 'Please enter a start date in the past'};
            }
        }
    } else {
        return { result: false, msg: 'Please indicate a start date.' };

    }
    if (!medOrder.getDirections() && (main._isRx || main._isSamples)) {
        return { result : false, msg : 'Please indicate directions.' };
    }

    var validateMed = this._validateMed.apply(this, arguments);
    if (!validateMed.result) {
        return validateMed;
    }

    return { result : true };
};

/** Wrap check for valid med and valid quantity/authRefill
 *
 * @param {Object} main
 * @param {Object} medOrder
 * @param {bool} isEPrescribe
 */
el8.appchart.dialog.ordermed.validateDraft = function(main, medOrder, isEPrescribe) {
    var validateMed = this._validateMed.apply(this, arguments);
    if (!validateMed.result) {
        return validateMed;
    }

    if (medOrder.getQuantity() && !medOrder.isQuantityNumerical()) {
        return {result: false, msg: 'Please enter a number in the quantity field.'};
    }

    if (medOrder.getAuthRefills() && !medOrder.isAuthRefillsNumerical()) {
        return {
            result: false,
            msg: 'Number of authorized refills must be a whole number, with no decimals.'
        };
    }

    return { result : true };
};

el8.appchart.dialog.ordermed._validateMed = function(main, medOrder, isEPrescribe) {
    if (!medOrder.getMedicationId()) {
        // Check to see if a new med needs to be created
        if (main._optDivs['newMed'] && !main._optDivs['newMed'].is(':hidden')) {
            if (!main._newMedSaved) {
                return {
                    result : false,
                    msg : 'Unknown medication: please add required detail.'
                };
            }

        // Otherwise, check for manual name; if none, then a problem
        } else if (!main._data['manual_medication_name']) {
            if (main._requiredFields['medication'].getVal()) {
                return {
                    result : false,
                    msg : 'Unknown medication: please add required detail.'
                };
            } else {
                return {result : false, msg : 'Please input a medication.'};
            }
        }
    }
    return {result: true};
};
